import React from "react";
import PolicyLayout from "@/components/PolicyLayout";

const ShippingPolicy = () => (
  <PolicyLayout
    title="Shipping Policy"
    kicker="Logistics & Delivery"
    intro="At GirlyGrove, we strive to deliver your orders safely and quickly. Here's everything you need to know about how your treasures travel."
    sections={[
      {
        heading: "Processing Time",
        paragraphs: ["All orders are processed within 1–3 business days after payment confirmation."],
      },
      {
        heading: "Delivery Time",
        bullets: [
          "Metro Cities: 3–7 business days",
          "Other Locations: 5–10 business days",
        ],
        paragraphs: ["Delivery timelines may vary during sales, festivals, or unforeseen circumstances."],
      },
      {
        heading: "Shipping Charges",
        bullets: [
          "Free shipping on prepaid orders above ₹999.",
          "Shipping charges, if applicable, will be displayed during checkout.",
        ],
      },
      {
        heading: "Order Tracking",
        paragraphs: ["Once your order is shipped, tracking details will be shared via email or SMS."],
      },
      {
        heading: "Delays",
        paragraphs: [
          "While we work with reliable logistics partners, GirlyGrove cannot be held responsible for delays caused by courier companies, weather conditions, or other circumstances beyond our control.",
        ],
      },
    ]}
  />
);

export default ShippingPolicy;
